/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import {
	BeanUser,
	IRequestReqPassword,
	IresponseReqPassword,
	ListQuestion
} from '@pacifico/interfaces/configurations-api.interface';
import { ConfigurationsApiService } from '@pacifico/services/api/configurations/configurations-api.service';
import { ReCaptchaV3Service } from 'ng-recaptcha';
export interface ISecQuestions {
	idquestion: string;
	answer: string;
	description: string;
}
@Component({
	selector: 'app-request-password',
	templateUrl: './request-password.component.html',
	styleUrls: ['./request-password.component.scss']
})
export class RequestPasswordComponent implements OnInit {
	@Output()
	hideRequestPasswordEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
	userCode = '';
	showformValidate = false;
	titleValidateData = 'Persona natural';
	reqUserValidate: IRequestReqPassword = { numeroDocumento: '', tipoDocumento: 1, captchaToken: '' };
	resUservalidate!: IresponseReqPassword;
	messageError = '';
	messageErrorCode = '';
	@Output() documentId = 0;
	@Output() securityQuestions: ISecQuestions[] = [];
	@Output() userData: BeanUser = { cip: '', email: '', personId: 0 };
	@ViewChild('myform') myform!: NgForm;

	constructor(
		private _configurationsApiService: ConfigurationsApiService,
		private _recaptchaV3Service: ReCaptchaV3Service
	) {}

	ngOnInit(): void {
		this.messageErrorCode = 'Debe ingresar un numero válido';
	}

	continueValidData(): void {
		if (
			this.myform?.controls.numberIdentityDocument?.touched &&
			this.myform?.controls.numberIdentityDocument?.valid &&
			!this.myform.pristine
		) {
			this._recaptchaV3Service.execute('login').subscribe((token) => {
				this.reqUserValidate = {
					numeroDocumento: this.userCode,
					tipoDocumento: this.validateCode(this.userCode),
					captchaToken: token
				};
				this._configurationsApiService.answersUser(this.reqUserValidate).subscribe((res) => {
					if (res.status.code === '0000') {
						this.resUservalidate = res.data;
						this.userData = res.data.beanUser;
						this.fillQuestions(this.resUservalidate.listQuestions);
						this.showformValidate = true;
					} else {
						this.messageError = res.status.message;
						this.myform.resetForm();
					}
				});
			});
		} else {
			this.messageErrorCode = 'Debe ingresar un numero válido';
			this.myform.resetForm('');
		}
	}

	validateCode(code: string): number {
		const size: number = code.length;
		let tipoDoc = 1;
		switch (size) {
			case 8: {
				tipoDoc = 1; //dni
				this.titleValidateData = 'Persona natural';
				break;
			}
			case 11: {
				tipoDoc = 2; //ruc
				this.titleValidateData = 'Persona jurídica';
				break;
			}
			default: {
				this.titleValidateData = 'Persona jurídica';
				tipoDoc = 1; //codigo socio
				break;
			}
		}
		this.documentId = tipoDoc;
		return tipoDoc;
	}

	fillQuestions(data: ListQuestion[]): void {
		this.securityQuestions = [];
		data.forEach((item) => {
			this.securityQuestions.push({ idquestion: item.codigoafiliacion, answer: '', description: item.descripcion });
		});
	}

	validInputCode(): boolean {
		return (
			this.myform?.controls.numberIdentityDocument?.touched && this.myform?.controls.numberIdentityDocument?.invalid
		);
	}

	disabledButton(): boolean {
		return (
			this.myform?.invalid ||
			(this.myform?.controls.numberIdentityDocument?.value?.length > 8 &&
				this.myform?.controls.numberIdentityDocument?.value?.length < 11)
		);
	}

	cancelRequest(value: boolean): void {
		this.userCode = '';
		this.showformValidate = !value;
		this.messageError = '';
	}

	fillSize(): void {
		if (this.userCode !== '' && this.userCode.length >= 3) {
			this.userCode = this.userCode.length < 8 ? this.userCode.padStart(7, '0') : this.userCode;
		}
	}
}
